import React from "react";
import styles from "./PhoneDialButton.module.css";
import phoneDialIcon from "../../images/phone_prevencher_icon.svg";
import { usePaycall } from "../../contexts/PaycallContext";
import type { TOutgoingDialMeta } from "../../services/paycall/paycall.types";

// A phone number the therapist can click to dial through Paycall. Falls back to plain
// text when there's no number to dial or the SIP line isn't registered.
function PhoneDialButton({
  phone,
  meta,
  textClassName = "",
  fallback = "",
}: {
  phone?: string | null;
  meta?: TOutgoingDialMeta;
  textClassName?: string;
  fallback?: string;
}) {
  const paycall = usePaycall();

  if (!phone?.trim() || paycall.sipStatus !== "registered") {
    return <span className={textClassName}>{phone || fallback}</span>;
  }

  return (
    <button
      type="button"
      className={styles.phoneDial}
      onClick={(e) => {
        e.stopPropagation();
        // dial() already closes the call widget when it fails (e.g. the call is ended
        // before the offer is ready) — catch so it isn't an unhandled rejection.
        paycall.dial(phone, meta).catch(() => undefined);
      }}
    >
      <img
        src={phoneDialIcon}
        alt=""
        width={16}
        height={16}
        className={styles.phoneIcon}
        aria-hidden
      />
      <span className={`${textClassName} ${styles.phoneText}`} dir="ltr">
        {phone}
      </span>
    </button>
  );
}

export default PhoneDialButton;
